/*
 * BioBio - carregador dos trilhos da pagina de aniversario.
 *
 * POR QUE ISSO EXISTE (nao e otimizacao, e correcao):
 * o recorte de uma colecao com escopo de variante (API 2026-07) vale pra
 * REQUISICAO inteira, nao pra colecao. Com duas colecoes na mesma pagina, o
 * recorte de uma contamina os produtos da outra: a Base apareceria com os tons
 * de 40% (e o preco de 40%) tambem no carrossel de queridinhos. Verificado em
 * 28/07 com theme dev; detalhe no Adendo 3 de
 * docs/specs/2026-07-27-collection-aniversario-design.md.
 *
 * Solucao: cada trilho e buscado na SUA propria requisicao
 * (/collections/<handle>?view=aniv-rail), onde o recorte sai correto.
 * Mesmo padrao do assets/biobio-bundle-selector-trio.js (?view=trio-resolve).
 *
 * O fragmento traz os cards ja com o bottom-sheet de tom; o biobio-kit-meter.js
 * usa delegacao no document, entao funciona em conteudo injetado.
 */
(function () {
  'use strict';

  // Guard de execucao unica: o Shopify NAO dedupa tag <script>, e o snippet do
  // rail carrega o asset uma vez por secao. Sem isso, N loaders concorrentes.
  if (window.__biobioAnivLoader) return;
  window.__biobioAnivLoader = true;

  var SEL = '[data-aniv-rail][data-aniv-url]';

  function carregar(rail, tentativa) {
    if (rail.dataset.anivLoaded === '1' || rail.dataset.anivLoading === '1') return;
    rail.dataset.anivLoading = '1';

    var url = rail.dataset.anivUrl;
    var limite = parseInt(rail.dataset.anivLimite, 10) || 12;
    // Piso de publicacao. Vive AQUI e nao no Liquid porque a contagem
    // server-side roda sob o escopo contaminado da pagina (mesmo motivo do
    // fetch); o fragmento e a unica contagem verdadeira.
    var minimo = parseInt(rail.dataset.anivMinimo, 10) || 0;
    tentativa = tentativa || 0;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        // O fragmento e uma lista de <li>; precisa de um <ul> pai pro parser
        // nao descartar os nos.
        tmp.innerHTML = '<ul>' + html + '</ul>';
        var itens = tmp.firstElementChild ? Array.prototype.slice.call(tmp.firstElementChild.children) : [];

        if (itens.length < minimo) {
          // Abaixo do piso (inclui colecao vazia): a secao inteira sai da
          // pagina, em vez de deixar um titulo com trilho quase vazio, que e o
          // modo de falha que o benchmark achou na Sallve e na Boca Rosa.
          removerSecao(rail);
          return;
        }

        var frag = document.createDocumentFragment();
        var escolhidos = itens.slice(0, limite);
        escolhidos.forEach(function (li) { frag.appendChild(li); });
        unicizarSheets(frag, rail.dataset.anivAncora || '');
        rail.innerHTML = '';
        rail.appendChild(frag);
        rail.dataset.anivLoaded = '1';
        rail.removeAttribute('aria-busy');

        document.dispatchEvent(new CustomEvent('aniv:rail-loaded', {
          bubbles: true,
          detail: { rail: rail, itens: itens.length },
        }));
      })
      .catch(function () {
        // Falha de REDE (nao e o mesmo que fragmento abaixo do piso): re-tenta
        // antes de desistir. Sem isso, um blip de 4G apagava a secao inteira,
        // inclusive o titulo e o "Ver tudo" que existem server-side justamente
        // pra sobreviver a ausencia de JS.
        rail.dataset.anivLoading = '0';
        if (tentativa < 2) {
          setTimeout(function () { carregar(rail, tentativa + 1); }, 1500 * (tentativa + 1));
          return;
        }
        removerSecao(rail);
      })
      .then(function () {
        if (rail.dataset.anivLoaded === '1') rail.dataset.anivLoading = '0';
      });
  }

  function removerSecao(rail) {
    // A banda (.aniv-band) sai junto: sem isso sobra uma faixa colorida vazia
    // quando o trilho cai abaixo do piso de publicacao.
    var secao = rail.closest('.aniv-section');
    var band = secao && secao.closest('.aniv-band');
    if (band) band.remove();
    else if (secao) secao.remove();
    removerChipOrfao(rail);
  }

  /*
   * O bottom-sheet de tom usa id="biobio-kit-sheet-<product.id>". Com o mesmo
   * produto em DOIS carrosseis (a Base entra em queridinhos e em ofertas, com
   * recortes de tom diferentes), o id duplica e o
   * document.querySelector(target) do kit-meter acha sempre o PRIMEIRO: clicar
   * em "Escolher tom" nas ofertas abria o sheet de 8 tons do outro carrossel.
   * Aqui cada trilho recebe seu proprio sufixo, o que torna o id unico e o
   * target coerente com o card clicado.
   */
  function unicizarSheets(frag, sufixo) {
    if (!sufixo) return;
    frag.querySelectorAll('.biobio-kit-sheet[id]').forEach(function (sheet) {
      var antigo = sheet.id;
      var novo = antigo + '--' + sufixo;
      sheet.id = novo;
      // querySelectorALL: o CTA nao e o unico que aponta pro sheet. Os swatches
      // de previa do card tambem apontam, e com querySelector so o primeiro era
      // reescrito: os swatches ficavam com o id antigo e o sheet nao abria.
      frag.querySelectorAll('[data-sheet-target="#' + antigo + '"]').forEach(function (g) {
        g.dataset.sheetTarget = '#' + novo;
      });
      // Os radios de tom sao agrupados por name; nomes iguais em dois trilhos
      // fariam a selecao de um desmarcar a do outro.
      sheet.querySelectorAll('input[type="radio"][name]').forEach(function (input) {
        input.name = input.name + '--' + sufixo;
      });
    });
  }

  // Chip apontando pra uma secao que nao existe mais e link quebrado.
  function removerChipOrfao(rail) {
    var id = rail.dataset.anivAncora;
    if (!id) return;
    var chip = document.querySelector('.aniv-chips__link[href="#' + id + '"]');
    if (chip && chip.parentElement) chip.parentElement.remove();
    var lista = document.querySelector('.aniv-chips');
    // Sobrou so o chip "Ver tudo": a faixa de navegacao perde a funcao.
    if (lista && lista.children.length <= 1) {
      var nav = lista.closest('nav');
      (nav || lista).remove();
    }
  }

  /*
   * Setas de trilho (Q6, so desktop/pointer fino). Montadas apos o fragmento
   * chegar (aniv:rail-loaded): sobre esqueleto nao ha o que navegar. O rail e
   * envolvido num wrapper posicionado pra ancorar as setas na zona da foto.
   *
   * A montagem e INCONDICIONAL: quem gateia a exibicao e o CSS
   * (@media (min-width: 750px) and (pointer: fine)), entao janela estreita no
   * load que depois alarga ganha as setas sem JS de resize. O estado de ponta
   * usa aria-disabled (nao disabled): botao disabled perde o foco do teclado no
   * momento em que desabilita sob ele.
   */
  var REDUZ_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function criarSeta(dir, rotulo) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'aniv-seta aniv-seta--' + dir;
    b.setAttribute('aria-label', rotulo);
    b.innerHTML = dir === 'prev' ? '&#8592;' : '&#8594;';
    return b;
  }

  function montarSetas(rail) {
    if (rail.parentElement && rail.parentElement.classList.contains('aniv-railwrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'aniv-railwrap';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);

    var prev = criarSeta('prev', 'Produtos anteriores');
    var next = criarSeta('next', 'Próximos produtos');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function passo() {
      return Math.max(rail.clientWidth * 0.8, 200);
    }
    function comportamento() {
      return REDUZ_MQ.matches ? 'auto' : 'smooth';
    }
    function sincronizar() {
      prev.setAttribute('aria-disabled', rail.scrollLeft < 10 ? 'true' : 'false');
      var fim = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 10;
      next.setAttribute('aria-disabled', fim ? 'true' : 'false');
    }
    function aoClicar(seta, direcao) {
      seta.addEventListener('click', function () {
        if (seta.getAttribute('aria-disabled') === 'true') return;
        rail.scrollBy({ left: direcao * passo(), behavior: comportamento() });
      });
    }

    aoClicar(prev, -1);
    aoClicar(next, 1);
    rail.addEventListener('scroll', sincronizar, { passive: true });
    sincronizar();
  }

  document.addEventListener('aniv:rail-loaded', function (e) {
    if (e.detail && e.detail.rail) montarSetas(e.detail.rail);
  });

  function iniciar() {
    var rails = document.querySelectorAll(SEL);
    if (!rails.length) return;

    // O primeiro trilho carrega imediato (fica na dobra ou logo abaixo dela);
    // os demais so quando chegam perto da viewport.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          carregar(e.target);
        });
      }, { rootMargin: '600px 0px' });

      Array.prototype.forEach.call(rails, function (rail, i) {
        if (i === 0) carregar(rail);
        else io.observe(rail);
      });
    } else {
      Array.prototype.forEach.call(rails, function (rail) { carregar(rail); });
    }

    // Clicar num chip rola pra uma secao que talvez ainda seja esqueleto (o
    // lazy so dispara a 600px). Carrega na hora pra nao rolar pro vazio nem
    // assistir a secao sumir depois.
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('.aniv-chips__link');
      if (!chip) return;
      var href = chip.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href === '#aniv-fecho') return;
      var secao = document.getElementById(href.slice(1));
      var alvo = secao && secao.querySelector(SEL);
      if (alvo) carregar(alvo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
